export const projects = [
  {
    title: 'Netflix Clone',
    subtitle: 'React & Firebase',
    description:
      'A clone for the UI of Netflix, with options to pay with stripe and fetchig data from the movies DB',
    image: '/images/netflixClone.png',
    link: 'https://netflix-clone-1a2fa.web.app/',
  },
  {
    title: 'Chess AI',
    subtitle: 'React & Stockfish API',
    description:
      'A sophisticated chess website using Stockfish API that always win',
    image: '/images/chess.jpg',
    link: 'https://chess-ai-637a5.web.app/',
  },
  {
    title: 'Sound To Notes',
    subtitle: 'Python',
    description:
      'A Mobile app - Still in development, finding frequencies and notes from audio using matplotlib, scipy and Machine Learning',
    image: '/images/Piano.jpg',
    link: 'https://github.com/shalevgerbi/Final-Project-v1.0',
  },
  {
    title: 'Library Website',
    subtitle: 'JSP & Servlet',
    description:
      'A Library Website using JSP & Servlet connectiong to Apache Derby DB and running on TomCat Server where you can borrow books and add students', 
    image: '/images/book.jpg',
    link: 'https://github.com/shalevgerbi/Web-Servlet-Library-For-Students',
  },
];
export const skills = [
  'Java',
  'C#',
  'Python',
  'C',
  'HTML',
  'CSS',
  'JavaScript',
  'React.js',
  'ASP.Net',
  'jQuery',
];
export const testimonials = [];
